<ng-container *ngIf="backgroundImage; else marqueeWithOptionCardTemplate">
    <img class="marquee-background-image" width="330" height="140" [ngSrc]="backgroundImage" [priority]="trackingPosition === 0" />
    <div [ngClass]="{ 'card-special-image': !tile.source?.isAutomatedMarquee, 'card-special-image-automated': tile.source?.isAutomatedMarquee }">
        <ng-container *ngTemplateOutlet="marqueeWithOptionCardTemplate"></ng-container>
    </div>
</ng-container>

<ng-template #marqueeWithOptionCardTemplate>
    <div class="marquee-card-header">
        <div class="six-pack-card-header-left">
            <div class="card-league" [style.color]="textColor">
                <vn-icon class="icon-alignment" size="11" [name]="'sports-' + event.sport.id"></vn-icon>
                <span>{{ event.league.name }}</span>
            </div>
            <ms-scoreboard-time class="card-date" [event]="event" [showStream]="isSixpackMarketMarquee" [style.color]="textColor">
            </ms-scoreboard-time>
        </div>
        <div class="six-pack-card-header-right" *ngIf="!empty">
            <div class="six-pack-market-name" *ngFor="let option of group?.options; first as first" [style.color]="textColor">{{ option }}</div>
        </div>
    </div>

    <div class="six-pack-event-wrapper" (click)="eventClick($event)">
        <a
            class="six-pack-info-wrapper"
            dsTouchClick
            [style.color]="textColor"
            [class.fixed]="false"
            [href]="eventUrl"
            [msRemoveHref]="shouldRemoveHref">
            <div *ngFor="let participant of event.participants; index as i">
                <div class="participant-wrapper" [class.participant2-name]="i === 1">
                    <ms-participant-image shouldRotate="true" [participantImage]="participant.image" [sportId]="event.sport.id">
                    </ms-participant-image>
                    <div class="participant-container">
                        <div class="participant" [title]="getParticipantName(i)">
                            <div class="participant-name" [ngClass]="[event.scoreboard?.started ? 'w-80' : 'w-100']">{{ getParticipantName(i) }}</div>
                            <div
                                class="participant-score-inline participant-score"
                                *ngIf="event.scoreboard?.started"
                                [class.non-baseball-column-score]="event.scoreboard.type !== scoreboardTypes.BaseballGame">
                                <span
                                    class="batting-indicator"
                                    *ngIf="baseballScore && baseballScore.currentlyServing"
                                    [class.hidden-visibility]="baseballScore.currentlyServing !== i + 1"></span
                                ><span class="font-weight-bold">{{ getParticipantScore(i) }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="divider" *ngIf="i === 0" [style.background-color]="textColor"></div>
            </div>
        </a>
        <div class="six-pack-group-container" [ngClass]="empty ? 'emptygroups' : ''">
            <ng-container *ngIf="empty; else optionGroupsView">
                <a class="empty-bet-now" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref">
                    <ms-bet-now-button [event]="event">
                        <div class="card-bet-now-button">{{ sitecore.marquee.EmptyMarketLinkText }}</div>
                    </ms-bet-now-button>
                    <div class="markets-suspended" [style.color]="textColor">
                        {{ sitecore.marquee.EmptyMarketLinkText }}
                        <span class="result-locked" [style.color]="textColor">
                            <vn-icon name="theme-locked-i" size="16"></vn-icon>
                        </span>
                    </div>
                </a>
            </ng-container>
            <ng-template #optionGroupsView>
                <ng-container>
                    <div class="six-pack-wrapper" [class.offline-sibling]="emptySiblings(group)" [class.offline-six-pack]="emptySixPack(group)">
                        <ms-six-pack-option-group
                            *ngFor="let childGroup of group?.childGroups"
                            [decorateAttribute]="decorateAttribute"
                            [optionGroup]="groupsMap[childGroup]"
                            [event]="event"
                            [group]="group"
                            [textColor]="textColor"
                            [trackingPosition]="trackingPosition"
                            [isAutomatedMarquee]="!!tile.source?.isAutomatedMarquee">
                        </ms-six-pack-option-group>
                    </div>
                </ng-container>
            </ng-template>
        </div>
    </div>
</ng-template>
